const technicalData = {
  name: {
    label: "Nom",
    invalid: {
      assertEmpty: "Ce nom ne doit pas être vide."
    },
  },
  codingValue: {
    label: "Valeur pour le code",
  },
  ciphered: {
    label: "Faut-il chiffrer cette donnée ?",
  },
  active: {
    label: "Cette donnée est-elle active ?",
  },
  availableOrder: {
    label: "Demandé lors d'une commande ?",
  },
  availableService: {
    label: "Demandé dans un service ?",
  },
  clientReadable: {
    label: "Visible par le client ?",
  },
  clientWritable: {
    label: "Modifiable par le client ?",
  },
  searchable: {
    label: "Disponible à la recherche ?"
  },
  searchCipheredMeaningfulCharacterMin: {
    label: "Premier character important (recherche chiffré)",
    invalid: {
      assertNumber: "Ce champ doit être un entier natural."
    },
  },
  searchCipheredMeaningfulCharacterMax: {
    label: "Dernier character important (recherche chiffré)",
    invalid: {
      assertNumber: "Ce champ doit être un entier natural."
    },
  },
  displayBillOrder: {
    label: "Affichage dans facture",
    invalid: {
      assertNumber: "Ce champ doit être un entier natural."
    },
  },
};

export default technicalData;
